import type { InputProps } from "@/components/ui/input";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from "@/components/ui/input-group";
import { cn } from "@/lib/utils";

/** Numeric input with a `$` / `%` affix (Paper TP-09 / TP-09a). */
export function AffixInput({
  prefix,
  suffix,
  className,
  ...props
}: InputProps & { prefix?: string; suffix?: string }) {
  return (
    <InputGroup className={cn("h-9", className)}>
      {prefix ? (
        <InputGroupAddon>
          <InputGroupText className="font-mono text-[13px]">{prefix}</InputGroupText>
        </InputGroupAddon>
      ) : null}
      <InputGroupInput inputMode="decimal" className="font-mono text-[13px] text-ink" {...props} />
      {suffix ? (
        <InputGroupAddon align="inline-end">
          <InputGroupText className="font-mono text-[13px]">{suffix}</InputGroupText>
        </InputGroupAddon>
      ) : null}
    </InputGroup>
  );
}

/** Parses a user-typed amount; null when empty or not a finite number. */
export function parseAmount(text: string): number | null {
  const trimmed = text.trim().replace(/,/g, "");
  if (trimmed === "") return null;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : null;
}

export const formatMoney = (value: number) =>
  `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
